import React from 'react';

import ToggleItem from './toggle-item';

import '../../styles/common/toggle-set.scss';

const ToggleSet = (props) => (
  <div className="toggle-set">
    {props.items.map((item, idx) => (
      <ToggleItem
        key={`toggle-item-${idx}`}
        label={ item.label }
        selected={ item.selected }
        onClick={ item.onClick }
      />
    ))}
  </div>
);

export default ToggleSet;